import {QuestionCircle} from 'react-bootstrap-icons'
import ReactTooltip from 'react-tooltip'



export default function HelpTip(props){

return(
    <>
        <QuestionCircle 
        style={{cursor: 'pointer', marginLeft: '9rem', marginTop: '-0.3rem'}}
        data-tip
        data-for='helptip'/>
        <ReactTooltip
        id="helptip"
        place="right" 
        effect="solid"
        type="light"
        multiline={true}
        className="tooltip"
        >
            <p><strong>How to interact with 3d models</strong></p>
            <ul>
                <li>ZOOM IN/OUT: use mouse wheel</li>
                <li>ROTATE MODEL: hold left mouse button and drag</li>
                <li>DRAG MODEL: hold right mouse button and drag</li>
            </ul>
        </ReactTooltip>
    </>
    )
}